import { render } from "./AppVideoEditor.vue?vue&type=template&id=08486023"
import script from "./AppVideoEditor.vue?vue&type=script&lang=js"
export * from "./AppVideoEditor.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__